import React, {useEffect, useRef} from 'react';


const ScrollContext = React.createContext();



// reducer
const reducer = (state, action) => {
  switch(action.type) {
    case 'headers':
    return {
      ...state,
      headers: action.value
    };
    case 'bottomToolbar':
    return {
      ...state,
      bottomToolbar: action.value
    };
    default: return state;
  }
};


// provider
const ScrollContextProvider = props => {

  const [state, dispatch] = React.useReducer(reducer, {
    headers: false,
    bottomToolbar: false,
  });
  const {tableElement} = props;
  const mounted = useRef(false);
  const stateTrack = useRef({headers: false, bottomToolbar: false})

  const scrollFunction = e => {
    if (mounted.current && tableElement.current) {
      const tableDims = tableElement.current.getBoundingClientRect();
      const tableHeight = tableDims.bottom - tableDims.top;
      // headers
      const headersFixed = tableDims.top <= 0 && tableDims.top <= 0 - tableHeight + 165
      ? false
      : tableDims.top <= 0 ? true : false;
      // bottom toolbar
      const bottomToolbarFixed = window.innerHeight > tableDims.top + 180 &&
      tableDims.bottom > 0 && tableDims.bottom > window.innerHeight
      ? true : false;

      if (headersFixed !== stateTrack.current.headers) {
        dispatch({type: 'headers', value: headersFixed});
        stateTrack.current.headers = headersFixed;
      }
      if (bottomToolbarFixed !== stateTrack.current.bottomToolbar)
        dispatch({type: 'bottomToolbar', value: bottomToolbarFixed});
        stateTrack.current.bottomToolbar = bottomToolbarFixed;
    }
  }

  useEffect(() => {
    mounted.current = true;
    window.addEventListener('scroll', scrollFunction)
    return(() => {
      mounted.current = false
      window.removeEventListener('scroll', scrollFunction);
    })
  }, [])



  return(
    <ScrollContext.Provider
      value={{
        headers: state.headers,
        bottomToolbar: state.bottomToolbar,
        scrollEffect: scrollFunction,
      }}
    >
      {props.children}
    </ScrollContext.Provider>
  )
}

const ScrollContextConsumer = ScrollContext.Consumer;

export {ScrollContext, ScrollContextProvider, ScrollContextConsumer};
